import { createIcon } from '@chakra-ui/icons';

export const BriefcaseIcon = createIcon({
  displayName: 'BriefcaseIcon',
  viewBox: '0 0 18 18',
  defaultProps: {
    fill: 'none',
  },
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C6.4536 0 5.2 1.2536 5.2 2.8H6.8C6.8 2.13726 7.33726 1.6 8 1.6H10C10.6627 1.6 11.2 2.13726 11.2 2.8H12.8C12.8 1.2536 11.5464 0 10 0H8ZM15 5.4H3C2.2268 5.4 1.6 6.0268 1.6 6.8V14.8C1.6 15.5732 2.2268 16.2 3 16.2H15C15.7732 16.2 16.4 15.5732 16.4 14.8V6.8C16.4 6.0268 15.7732 5.4 15 5.4ZM3 3.8C1.34315 3.8 0 5.14315 0 6.8V14.8C0 16.4569 1.34315 17.8 3 17.8H15C16.6569 17.8 18 16.4569 18 14.8V6.8C18 5.14315 16.6569 3.8 15 3.8H3ZM5.2 8.8C5.2 8.35817 5.55817 8 6 8H12C12.4418 8 12.8 8.35817 12.8 8.8C12.8 9.24183 12.4418 9.6 12 9.6H6C5.55817 9.6 5.2 9.24183 5.2 8.8Z"
      fill="currentColor"
    />
  ),
});
